import { render } from "./InvestmentList.vue?vue&type=template&id=e291af40"
import script from "./InvestmentList.vue?vue&type=script&lang=js"
export * from "./InvestmentList.vue?vue&type=script&lang=js"

import "./InvestmentList.vue?vue&type=style&index=0&id=e291af40&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__